import type {
  ClipTimelineMarkers,
  TimelineMarker,
} from '../transcript/hooks/useTimelineMarkers';
import type { ClipCardSpan } from './sceneStripBlocks';

const toSpan = (marker: TimelineMarker, label: string): ClipCardSpan => ({
  id: marker.id,
  start: marker.time,
  end: marker.endTime,
  label,
});

/**
 * The cards that can hold the screen on their own, for naming the stretches of
 * the progress rail that belong to no scene (`buildRailBlocks`).
 *
 * Intro and end cards only: a name card or an overlay is drawn over the video,
 * so it never leaves a stretch of the clip outside every scene. The label is
 * the kind of card, not the composition template's name — the template is
 * already named in the Templates panel, and the rail is answering "what is
 * playing here", which every intro card answers the same way.
 */
export function cardSpansFromMarkers(
  markers: ClipTimelineMarkers,
): ClipCardSpan[] {
  return [
    ...markers.intro.map(marker => toSpan(marker, 'Intro Card')),
    ...markers.end.map(marker => toSpan(marker, 'End Card')),
  ];
}
